import { useEffect, useState } from 'react';
import { api } from '../../../utils/api';
import { pipelineBannerItems } from './pipelineHealth.js';
import { useEnvironment } from '../../../hooks/useEnvironment';

// Shown at the very top of Quote Assessment while any pricing upstream is down (sold / vision /
// OCR — /api/ops/pipeline-health). One block per down service, naming it and the provider error.
// Supersedes SoldLaneBanner. Healthy, unknown and failed lookups render nothing: Sentry owns the
// alarm, this is context at the point of decision.
export default function PipelineHealthBanner() {
    const [status, setStatus] = useState(null);
    const environment = useEnvironment();

    useEffect(() => {
        let alive = true;
        api.get('/api/ops/pipeline-health')
            .then((s) => { if (alive) setStatus(s); })
            .catch((e) => { console.warn('pipeline health unavailable:', e?.message); });
        return () => { alive = false; };
    }, []);

    const items = pipelineBannerItems(status, environment);
    if (items.length === 0) return null;
    return (
        <div data-testid="pipeline-health-banner">
            {items.map((item) => (
                <div key={item.key} className={`qa-banner qa-banner-${{ degraded: 'degraded', info: 'info' }[item.severity] || 'warning'}`} role="status" data-severity={item.severity} data-testid={`pipeline-banner-${item.key}`}>
                    <strong>{item.title}.</strong> {item.body}
                    {item.detail ? <span className="qa-banner-detail"> ({item.detail})</span> : null}
                </div>
            ))}
        </div>
    );
}
